import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const CONVERSATIONS_URL = `${BASE_URL}/loadConversations`;
export const CONTACTS_URL = (username) => `${BASE_URL}/rest/v1.0/search/relations/${username}`;
export const DELETE_CONVERSATION_URL = `${BASE_URL}/loadConversations?threadId={threadId}`;
export const FILE_UPLOAD_URL = `${BASE_URL}/testCommunicatorFileUpload`;
export const FUNCLUB_DATA_URL = `${BASE_URL}/rest/v1.0/profile/{username}/fanclub`;
export const FUNCLUB_FANS_URL = `${BASE_URL}/rest/v1.0/profile/{username}/fanclub/fans`;
export const REPORT_ABUSE_URL = `${BASE_URL}/profiles/reportAbuse`;
export const UNREAD_THREADS_URL = `${BASE_URL}/mail/unreadThreads`;
